import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { MdKeyboardBackspace } from "react-icons/md";
import { InterviewHistoryAction } from "./../../../Redux/action/InterviewHistoryAction";
import TableHeader from "../../Common/TableHeader";
import UpdateInterview from "./UpdateInterview";
import { ToastContainer, toast } from "react-toastify";

import ReshceduleForAction from "../interview/RescheduleForAction";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CancelInterview from "../../Vendor/interview/CancelInterviewComponent"
import Pagination from '../../Common/Pagination/Pagination';
import ChangeInterviewStatus from "./ChangeInterviewStatus";


const ITEM_HEIGHT = 48;

function DotsMenu({ data,pageNumber }) {
  const [canInfo, setCanInfo] = useState("");
  const [isopen, setisOpen] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  console.log("data in trreee dot", data)

  const handleSchedule = (e, item) => {
    e.stopPropagation();
    setCanInfo(item);
    setisOpen(true);
  };

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (event) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        style={{ margin: "0px", padding: "0px" }}
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      {
        (data?.actionPerformed == null && data.candidateInterviewStatus !== "REJECT") && (
          <Menu
            disableAutoFocusItem={data?.interviewStatus == "COMPLETED"}
            id="long-menu"
            MenuListProps={{
              "aria-labelledby": "long-button",
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            PaperProps={{
              style: {
                maxHeight: ITEM_HEIGHT * 4.5,
                width: "16ch",
              },
            }}
          >
            {(
              data?.interviewStatus == "CANCELLED") && (
              <MenuItem >
                  <ReshceduleForAction setAnchorEl={setAnchorEl} pageNumber={pageNumber}  data={data} text={"Reschedule"} />
                </MenuItem>
              )}

            {(data?.interviewStatus == "COMPLETED" && data.candidateInterviewStatus == 'NEXT_ROUND') && (
              <MenuItem >
                <ReshceduleForAction setAnchorEl={setAnchorEl} pageNumber={pageNumber} data={data} text={"Next Round"} />
              </MenuItem>
            )}
            {(data?.interviewStatus == "COMPLETED" && data.candidateInterviewStatus == 'ONHOLD') && (
              <MenuItem >
                <ChangeInterviewStatus setAnchorEl={setAnchorEl} pageNumber={pageNumber} id={data?.interviewId} />
              </MenuItem>
            )}
            {data?.interviewStatus !== "CANCELLED" && (
              <MenuItem >
                <CancelInterview setAnchorEl={setAnchorEl} data={data?.interviewId} text={"Cancel"} />
              </MenuItem>
            )}
          </Menu>
        )}
    </div>
  );
}

// -----------------------------------------------------------------------------------------------------
const InterviewHistory = () => {
  // var today = new Date();
  // var dd = String(today.getDate()).padStart(2, "0");
  // var mm = String(today.getMonth() + 1).padStart(2, "0");
  // var yyyy = today.getFullYear();
  // today = yyyy + "-" + mm + "-" + dd;
  const navigate = useNavigate();

  const [pageNumber, setPageNumber] = useState(0);
  const { userResult } = useSelector((state) => state.Auth);
  let vendorid = userResult?.vendorid;
  const userInfo = useSelector((state) => state.InterviewHistory.result.content);
  const totalPages = useSelector((state) => state.InterviewHistory.result.totalPages);

  // alert(totalPages)
  const arr = [1];
  // let navigate = useNavigate();
  let dispatch = useDispatch();

  useEffect(() => {
    dispatch(InterviewHistoryAction(vendorid, pageNumber));
  }, [pageNumber]);

  const handlePageChange = (page) => {
    setPageNumber(page);
  };

  return (
    <div>
      <ToastContainer/>
      <div
        className=""
      >
        <div className="common_wrapper mt-4">
          <div className="card-header common_table_header">
            Interview History
          </div>
          <div className="card-body" style={{overflowY:"auto"}}>
            <table className="table-data" style={{ width: "100%", textAlign: "center", fontSize: '14px' }}>
              <thead>
                <tr>
                  <th className="fw_500" scope="col">Job ID</th>
                  <th className="fw_500" scope="col">Candidate Name</th>
                  <th className="fw_500" scope="col">Round</th>
                  <th className="fw_500" scope="col">Designation</th>
                  <th className="fw_500" scope="col">Date</th>
                  <th className="fw_500" scope="col">Start time</th>
                  <th className="fw_500" scope="col">Duration</th>
                  <th className="fw_500" scope="col">Interview Type</th>
                  <th className="fw_500" scope="col">Interview Status</th>
                  {/* <th className="fw_500" scope="col">Status</th> */}
                  <th className="fw_500" scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                {userInfo &&
                  userInfo.map((item, i) => {
                    return (
                      <>
                        <tr
                          key={i}>
                          <td style={{ cursor: "pointer" }}
                          onClick={() =>
                            navigate(
                              `/job-details/${item.jobId}`
                            )
                          }>{item.jobUuid}</td>
                          <td>{item.candidateName}</td>
                          <td style={{ cursor: "pointer" }}
                            onClick={() =>
                              navigate(`/interview_all_rounds/${item.uuid}`, {
                                state: { myData: "candidate" }, // 👈 send state here
                              })
                            }>{item.round}</td>
                          <td>{item.jobPosition}</td>
                          <td> {
                            item?.interviewDate.split(" ")[0].split("-")[2] + "-" +
                            item?.interviewDate.split(" ")[0].split("-")[1] + "-" +
                            item?.interviewDate.split(" ")[0].split("-")[0]
                            || "N/A"}</td>
                          <td>{item.interviewStartTime || "N/A"}</td>
                          <td>{item.duration}</td>
                          <td>{item.inteviewType}</td>
                          <td><div style={{ minWidth: "80%" }}
                            className={`w-75 m-auto ${["ONHOLD", "PENDING"].includes(item.candidateInterviewStatus)
                              ? "yellow_status"
                              : ["CANCELLED", "REJECT"].includes(item.candidateInterviewStatus)
                                ? "red_status"
                                : ["SELECT", "NEXT_ROUND"].includes(item.candidateInterviewStatus)
                                  ? "green_status"
                                  : ""
                              }`}
                          >
                            {item.candidateInterviewStatus === 'ONHOLD' ? 'On Hold' :
                              item.candidateInterviewStatus === 'NEXT_ROUND' ? 'Next Round' :
                                item.candidateInterviewStatus === 'SELECT' ? 'Selected' :
                                  item.candidateInterviewStatus === 'REJECT' ? 'Rejected' :
                                    item.candidateInterviewStatus === 'PENDING' ? 'In Progress' : item.candidateInterviewStatus}
                          </div></td>
                          {/* <td>
                            {<div style={{ minWidth: "80%" }} className={`w-75 m-auto ${item.interviewStatus === "SCHEDULED" ? "yellow_status"
                              : item.interviewStatus === "CANCELLED" ? "red_status"
                                : "green_status"
                              }`}
                            >
                              {item.interviewStatus}
                            </div>}</td> */}
                          <td>
                            {item.candidateInterviewStatus === "SELECT" || item.candidateInterviewStatus === "REJECT" ? 'N/A' :
                             <DotsMenu pageNumber={pageNumber} data={item} />
                          }
                          </td>
                          {/* <td><Link to=""><button>Rescheduled</button></Link></td> */}
                          {/* <td><button className="schedule-button" style={{ background: "rgb(28, 101, 151)", color: "white" }}><UpdateInterview data={item.candidateId} jobId={item.jobId} uuid={item.uuid} round={item.round}/></button></td> */}
                        </tr>
                      </>
                    );
                  })}
              </tbody>
            </table>
            {userInfo?.length === 0 && (
              <div className="text-center mt-5">
                <h5>No Data Available</h5>
              </div>
            )}
          </div>
        </div>
      </div>
      {
        totalPages > 0 &&
        <Pagination totalPages={totalPages} currentPage={pageNumber} onPageChange={handlePageChange} />
      }
    </div>
  );
};

export default InterviewHistory;
